import {
  FETCH_VOUCHER,
  SUBMIT_VOUCHER,
  DELETE_VOUCHER,
  REFRESH_VOUCHER_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function voucher(state = initialState, action) {
  switch (action.type) {
    case FETCH_VOUCHER:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_VOUCHER:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_VOUCHER:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_VOUCHER_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
